<div
  class="flex flex-col gap-1"
  [class]="frameClass()"
  [class.opacity-60]="dimmed()"
  [attr.data-testid]="testId()"
>
  <span class="text-muted-color text-sm">{{ label() }}</span>
  <span [class]="valueClass()">{{ displayValue() }}</span>
  <ng-content />
</div>
